import {Component, OnInit, Inject, HostListener, OnDestroy} from '@angular/core';
import {Router, NavigationEnd, ActivationEnd} from '@angular/router';
import {PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, isPlatformServer, registerLocaleData} from '@angular/common';
import zh from '@angular/common/locales/zh';
import {Debounced, Throttle} from './shared/utils/throttle';
import {EventBusService} from './shared/service/event-bus.service';
import {WindowGrid} from './shared/model/common.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(PLATFORM_ID) private platformId,
    private router: Router,
    private eventBus: EventBusService,
  ) {
  }

  private throttle = new Throttle();
  private throttleUse: any;

  ngOnInit(): void {
    registerLocaleData(zh);
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.subscribe((event: NavigationEnd) => {
        // 当导航成功结束时执行
        if (event instanceof ActivationEnd) {
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }
      });
      this.throttleUse = this.throttle.use(() => {
        this.responsiveGrid();
      }, this, 100);
      this.responsiveGrid();
      console.log('当前环境：客户端');
    } else if (isPlatformServer(this.platformId)) {
      console.log('当前环境：服务端');
    }
  }

  ngOnDestroy(): void {
    this.throttle.destroy();
  }

  @HostListener('window:resize', ['$event']) onWindowResize(): void {
    // 节流
    this.throttleUse();
  }

  // @HostListener('beforeunload', ['$event']) onWindowBeforeunload(): void {
  //   // 节流
  //   this.eventBus.onWindowResizeEvent.next({})
  // }

  responsiveGrid(): void {
    const width: number = window.innerWidth;
    const height: number = window.innerHeight;
    let grid: WindowGrid = 'xxl';
    if (width < 576) {
      grid = 'xs';
    } else if (width >= 576 && width < 768) {
      grid = 'sm';
    } else if (width >= 768 && width < 992) {
      grid = 'md';
    } else if (width >= 992 && width < 1200) {
      grid = 'lg';
    } else if (width >= 1200 && width < 1600) {
      grid = 'xl';
    } else if (width >= 1600) {
      grid = 'xxl';
    }

    this.eventBus.onWindowResizeEvent.next({
      grid,
      width,
      height,
    });
  }
}

